// ─────────────────────────────────────────────
//  Summary.jsx
//  Desglose: consumo, propina, total
// ─────────────────────────────────────────────

import React from 'react';
import styles from './Summary.module.css';
import { formatCurrency } from '../../utils/format';

export default function Summary({
	amount,
	tipPct,
	tipAmount,
	total,
	hasAmount,
	useIntegerAmounts = false,
}) {
	return (
		<section className={styles.card} aria-label="Desglose total">
			{/* <p className={styles.sectionLabel}>Desglose total</p> */}

			<div className={styles.row}>
				<span className={styles.rowLabel}>Consumo</span>
				<span className={styles.rowValue}>
					{hasAmount ? formatCurrency(amount, { forceInteger: useIntegerAmounts }) : '—'}
				</span>
			</div>


			<div className={styles.row}>
				<span className={styles.rowLabel}>
					Propina{' '}
					<span className={styles.pctTag}>({tipPct}%)</span>
				</span>
				<span className={`${styles.rowValue} ${styles.tipColor}`}>
					{hasAmount ? formatCurrency(tipAmount, { forceInteger: useIntegerAmounts }) : '—'}
				</span>
			</div>


			<div className={styles.divider} />


			<div className={`${styles.row} ${styles.totalRow}`}>
				<span className={styles.totalLabel}>Total a pagar</span>
				<span className={`${styles.totalValue} ${styles.totalColor}`}>
					{hasAmount ? formatCurrency(total, { forceInteger: useIntegerAmounts }) : '—'}
				</span>
			</div>
		</section>
	);
}